export enum enumDLIDocumentationList {
  'Account Pack' = 1,
  'Shamwari Check',
  'Account Package Card Replacement',
  'Proof of Address',
  'Proof of Income',
  'Application',
  'PEP & Terrorist Check',
  'Application Bus',
  'Client ID',
  'Termination of Free Funeral Cover',
  'Application T&C',
  'SureCard Account Classification Upgrade',
  'Work Permit',
  'Asylum Seeker Permi',
  'DHA Check',
  'CellBank Service Application',
  'Temporary ID',
  'Temporary Passport',
  'Birth Certificate',
  'Bookkeeper Letter',
  'Passport',
  'Unknown',
  'Card Replacement',
  'Card Signature',
  'CIPC Check',
  'CIPC Reg Ver',
  'CK 1',
  'CK 2',
  'Client Interview',
  'Funeral Benefit Application',
  'Funeral Policy Certificate',
  'World Check Bus',
  'Salary Instruction',
  'Clients ID',
  'Dormancy React',
  'Tax Clear Cert',
  'PEP & Terrorist Perv',
  'ID Verification',
  'Historic Document',
  'ID Bus Client',
  'Indemnity Form',
  'Proof of Bus Add',
  'KYC Business',
  'Letter of Authority',
  'Proof of Res Bus',
  'Limit Increase Bus',
  'Memo Inc COR15.1A',
  'Mobile Banking Serv',
  'Reg Cert COR14.3',
  'Notice Inc COR14.1',
  'Terms and Conditions',
  'Online Banking App',
  'Trust Deed',
  'Passport Check',
  'PEP Report Form',
  'Refugee Status Perm',
  'VAT Document'
}

export namespace enumDLIDocumentationList {
  export function values() {
    return Object.keys(enumDLIDocumentationList).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
